export default "__VITE_ASSET__DbHo5DIf__"